import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`This action sets, overwrites, or removes the existing `}<a parentName="p" {...{
          "href": "/api/../api/projects/custom-fields"
        }}>{`custom`}</a>{` type and fields for an existing order `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setLineItemCustomType"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`type`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#resourceidentifier"
          }}>{`ResourceIdentifier`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/types#type"
          }}>{`Type`}</a>{` - Optional`}<br parentName="li"></br>
          {`If set, the `}<a parentName="li" {...{
            "href": "/api/../api/projects/custom-fields"
          }}>{`custom`}</a>{` type is set to this new value.`}<br parentName="li"></br>
          {`If absent, the `}<a parentName="li" {...{
            "href": "/api/../api/projects/custom-fields"
          }}>{`custom`}</a>{` type and any existing `}<a parentName="li" {...{
            "href": "/api/../api/projects/custom-fields#customfields"
          }}>{`CustomFields`}</a>{` are removed at the same time.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`lineItemId`}</inlineCode>{` - String`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`fields`}</inlineCode>{` - A valid JSON object, based on the `}<a parentName="li" {...{
            "href": "/api/../api/projects/types#fielddefinition"
          }}>{`FieldDefinitions`}</a>{` of the `}<a parentName="li" {...{
            "href": "/api/../api/projects/types#type"
          }}>{`Type`}</a>{` - Optional`}<br parentName="li"></br>
          {`If set, the `}<a parentName="li" {...{
            "href": "/api/../api/projects/custom-fields"
          }}>{`custom`}</a>{` fields are set to this new value.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      